import { useEffect } from 'react';

import { Alert, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

import { ConfirmModal } from 'components/modal';
import { Block, OneColumn } from 'components/page';
import { useClientContext } from 'context/ClientContext';
import { useLoaderContext } from 'context/LoaderContext';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { usePedidoBeforeUnload } from 'pages/compra/pedido/hooks/usePedidoBeforeUnload';
import {
    PedidoBbar,
    PedidoCartInfo,
    PedidoCompraCartAside,
    PedidoCompraListContainer,
    PedidoCompraListFilter,
    PedidoCompraListFuncionarioFilter,
    PedidoCompraUsuarioInfo,
    PedidoGradeText,
} from 'pages/compra/pedido/components';
import { useGetCarrinho, useQueryProdutos, useQueryTotalizador } from 'pages/compra/pedido/hooks';
import { getErrorMessage } from 'util/error';

export function PedidoCompraListComp() {
    const { isDownMd, isDownLg } = useBreakpoints();
    const {
        configPedido,
        isOpenInfoModal,
        setIsOpenInfoModal,
        dataInfoModal,
        isOpenMultiploModal,
        setIsOpenMultiploModal,
        produtosRequest,
        isSavingCarrinho,
    } = usePedidoCompraContext();
    const { tipoPedido } = useClientContext();
    const { isFetching: isFetchingCart } = useGetCarrinho();
    const { error, isFetching } = useQueryProdutos();
    const [errorContent] = getErrorMessage(error);
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';
    const isTipoPedidoPadrao = tipoPedido === 'padrao';

    usePedidoBeforeUnload();

    useLoaderContext(isSavingCarrinho);

    useQueryTotalizador();

    useEffect(() => {
        if (isFetching) window.scrollTo(0, 0);
    }, [isFetching]);

    return (
        <>
            <ConfirmModal
                title="Aviso"
                confirmText="Ok"
                showCancel={false}
                open={isOpenInfoModal}
                setOpen={setIsOpenInfoModal}
                text={dataInfoModal}
                confirm={() => setIsOpenInfoModal(false)}
            />

            <ConfirmModal
                title="Aviso"
                text={'A quantidade informada é igual ou superior a 10 múltiplos do produto'}
                confirmText="Ok"
                showCancel={false}
                open={isOpenMultiploModal}
                setOpen={setIsOpenMultiploModal}
                confirm={() => setIsOpenMultiploModal(false)}
            />

            <OneColumn title="Novo Pedido" listType={!isDownMd} extraContent={isTipoPedidoPadrao && <PedidoGradeText />}>
                {isTipoPedidoFuncionario && (
                    <>
                        <PedidoCompraUsuarioInfo />

                        <PedidoCompraListFuncionarioFilter />
                    </>
                )}

                {isTipoPedidoPadrao && <PedidoCompraListFilter />}

                <Box
                    sx={{
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', lg: '9fr 3fr' },
                        gap: 2,
                    }}
                >
                    <Box sx={{ minWidth: 0 }}>
                        {!configPedido && <Alert severity="info">Selecione um filtro para iniciar.</Alert>}

                        {isFetching && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <CircularProgress />
                            </Box>
                        )}

                        {!isFetching && produtosRequest.length > 0 && <PedidoCompraListContainer />}

                        {!isFetching && configPedido && !produtosRequest.length && (
                            <Alert severity="info">Não foram localizados produtos. Tente novamente</Alert>
                        )}

                        {configPedido && errorContent && <Alert severity="error">{errorContent}</Alert>}
                    </Box>

                    {!isDownLg && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                position: 'sticky',
                                top: 16,
                                alignSelf: 'flex-start',
                                maxHeight: 'calc(100dvh - 90px)',
                                minWidth: 0,
                            }}
                        >
                            <Block>
                                <PedidoCartInfo />
                            </Block>

                            {configPedido && <PedidoCompraCartAside isFetching={isFetchingCart} />}
                        </Box>
                    )}
                </Box>

                {configPedido && <PedidoBbar />}
            </OneColumn>
        </>
    );
}
